/*
 * View for Kb Response Type Usage
 */

define([
  "marionette",
  "modules/accountAdmin/kbWizardModal/kbResponseTypeUsage/template/kbResponseTypeUsageTemplate.html",
], function (Marionette, KbResponseTypeUsageTemplate) {
  var KbResponseTypeUsageView = {};

  KbResponseTypeUsageView.kbResponseTypeUsageLayout = Marionette.Layout.extend({
    template: KbResponseTypeUsageTemplate,
    regions: {
      responseType: "#responseTypeUsage",
    },
  });

  return KbResponseTypeUsageView;
});
